import styled from "styled-components";

export default styled.table`
  width: 100%;

  & tr:first-child {
    border-top: 0;
  }
`;
